'use strict';

/* globals window, require, $, utils, Android */

$(window).on('action:ajaxify.end', function (event, data) {
    if (data.tpl_url === 'groups/details') {
        $('#video-chat-join-btn').click(function () {
            var conferenceContainer = $('#video-chat-conference');
            conferenceContainer.show();
            $('#video-chat-join').hide();
            
            require(['conference'], function (conference) {
                socket.emit('plugins.conferences.getGroupConference', ajaxify.data.group.name, function (err, conferenceData) {
                    if (err) {
                        return app.alertError(err.message);
                    }
                    
                    if (typeof Android !== 'undefined') {
                        Android.openJitsi(conferenceData.roomName, conferenceData.username, conferenceData.jwt);
                    } else if (typeof window.webkit !== 'undefined') {
                        window.webkit.messageHandlers.openJitsi.postMessage({ room: conferenceData.roomName, username: conferenceData.username, jwt: conferenceData.jwt });
                    } else {
                        conference.init(conferenceData.roomName, conferenceData.server, conferenceData.username, conferenceData.jwt); 
                    }                    
                });
            });
        });
    }
});

$(window).on('jitsi:call:ended', function () {
    $('#video-chat-conference').hide();
    $('#jitsi-conference').html('');
    $('#video-chat-join').show();
});
